import { Injectable } from '@angular/core'

import { AUTHORIZATION_STATUS } from '../model/auth-status'
import { REFERRAL_STATUS } from '../model/referral-status'
import { AuthenticatedRestService } from './auth-rest.service'

export enum NecessityType {
  AUTHORIZATION = 'authorization',
  REFERRAL = 'referral',
}

export type NecessityStatus = AUTHORIZATION_STATUS | REFERRAL_STATUS

export interface SaveNecessityParams extends Record<string, any> {
  appointmentId: string
  type: NecessityType
  status: NecessityStatus
  insuranceId: string
}

@Injectable({
  providedIn: 'root',
})
export class NecessityService extends AuthenticatedRestService {
  public save(params: SaveNecessityParams) {
    return this.put(`/appointments/${encodeURIComponent(String(params.appointmentId ?? ''))}/necessity`, params)
  }

  public fetch(params: { appointmentId: string, insuranceId: string, type: NecessityType }) {
    const route = `/appointments/${encodeURIComponent(String(params.appointmentId ?? ''))}/necessity`
    const httpParams = this.convertToParams({
      insuranceId: params.insuranceId,
      type: params.type,
    })

    return super.get<{ status: NecessityStatus }>(route, httpParams)
  }
}
